import React from 'react';

import MunicipalityTeaser from './Teaser';
import MunicipalityFull from './Full';

const Municipality = ({ viewMode, ...props }) => {
  switch (viewMode) {
    case 'teaser':
      return <MunicipalityTeaser {...props} />;
    default:
      return <MunicipalityFull {...props} />;
  }
};

export default Municipality;
